export default __webpack_public_path__ + "static/media/logo-main.6706e5d8.png";